import { render, staticRenderFns } from "./orderMerge.vue?vue&type=template&id=1fd079a2&scoped=true"
import script from "./orderMerge.vue?vue&type=script&lang=js"
export * from "./orderMerge.vue?vue&type=script&lang=js"
import style0 from "./orderMerge.vue?vue&type=style&index=0&id=1fd079a2&prod&scoped=true&lang=css"
import style1 from "./orderMerge.vue?vue&type=style&index=1&id=1fd079a2&prod&less=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd079a2",
  null
  
)

export default component.exports